import DownIcon from "../../../../media/DownIcon"
import { SectionDataHeatmapProps } from "../SectionDataHeatmap/SectionDataHeatmap.types"
import SectionDataHeatmapVertical from "../SectionDataHeatmap/SectionDataHeatmapVertical"
import { HeatmapSectionProp } from "./HeatmapSection.types"
import "./HeatmapSection.css"
import { useRef } from "react"
import SectionDataHeatmap from "../SectionDataHeatmap/SectionDataHeatmap"

const HeatmapSection = (props: HeatmapSectionProp) => {

  const {
    heatmap,
    backgroundValue,
    maxValue,
    minValue,
    offsetStart,
    offsetEnd,
    showAssetBaseline,
    vertical
  } = props

  const ref = useRef(null)

  if (vertical) {
    return (
      <div className="analysis-section section-heatmap-container-vertical">
        <div className="section-heatmap-key-vertical" style={{height: heatmap.width/2}}>
          {backgroundValue !== 0 && maxValue !== 255 && (
            <div className="section-key-values heatmap-label">
              <p>Min signal: {Math.round(minValue)}</p>
              {backgroundValue && showAssetBaseline && (
                <div 
                  className="asset-baseline-vertical"
                  style={{top: `${Math.round((backgroundValue /255)*100)}%`}}
                >
                  <p className="background-pipe-label">{`Asset Baseline: 0`}</p>
                  <DownIcon />
                </div>
              )}
              <p>Max signal: {Math.round(maxValue)}</p>
            </div>
          )}
          <div className="section-heatmap-key-container-vertical">  
            <SectionDataHeatmapVertical
              width={heatmap.width}
              selectedScan={0}
              colourPalette={heatmap.colourPalette}
              onSelectScan={() => {}}
              heatmaps={[[[...Array(255)].map((x, i) => 254-i)]]}
              heatmapMask={null}
              highlightMax={false}
              highlightMin={false}
              scanPixelHeight={16}
              scanPositionMetadata={[]}
              interactionEnabled={false}
              canvasRef={ref}
              />
          </div>
        </div>

        <SectionDataHeatmapVertical
          {...heatmap}
        />
        <div className="offset-container-vertical heatmap-label" style={{height: heatmap.width/2}}>
          <p>Offset end: {offsetEnd}mm</p>
          <p>Offset start: {offsetStart}mm</p>
        </div>
      </div>
    )
  } else {
    return (
      <div className="analysis-section section-heatmap-container-horizontal">
        <div className="section-heatmap-key-horizontal" style={{width: heatmap.width}}>
          {backgroundValue !== 0 && maxValue !== 255 && (
            <div className="section-key-values heatmap-label">
              <p>Min signal: {Math.round(minValue)}</p>
              {backgroundValue && showAssetBaseline && (
                <div 
                  className="asset-baseline-horizontal"
                  style={{left: `${Math.round((backgroundValue /255)*100)}%`}}
                >
                  <p className="background-pipe-label">{`Asset Baseline: 0`}</p>
                  <DownIcon />
                </div>
              )}
              <p>Max signal: {Math.round(maxValue)}</p>
            </div>
          )}
          <div className="section-heatmap-key-container-horizontal">  
            <SectionDataHeatmap
              width={heatmap.width}
              selectedScan={0}
              colourPalette={heatmap.colourPalette}
              onSelectScan={() => {}}
              heatmaps={[[[...Array(255)].map((x, i) => i)]]}
              heatmapMask={null}
              highlightMax={false}
              highlightMin={false}
              scanPixelHeight={16}
              scanPositionMetadata={[]}
              interactionEnabled={false}
              canvasRef={ref}
              />
          </div>
        </div>

        <SectionDataHeatmap
          {...heatmap}
        />
        <div className="offset-container-horizontal heatmap-label" style={{width: heatmap.width}}>
          <p>Offset start: {offsetStart}mm</p>
          <p>Offset end: {offsetEnd}mm</p>
        </div>
      </div>
    )
  }
}

export default HeatmapSection